import { safeConvertToUUID } from 'uuid-encoding';

export const convertTeamToID = (teams: { _id: string; name: string }[]) => {
  return teams?.map(team => safeConvertToUUID(team?._id));
};
